const AddressFunction = {
  HQ: 'HQ',
  Worksite: 'Worksite',
  Office: 'Office',
  Shop: 'Shop',
  Mailbox: 'Mailbox',
};

export default AddressFunction;
